import React from 'react';

import { Box, styled, Typography } from '@mui/material';

import { LeaderboardTooltip } from './LeaderboardTooltip';
import { LeaderBoardUser } from './leaderboardTypes';

const StyledLeaderboardScore = styled(Typography)(({ theme }) => {
  return {
    width: 60,
    height: 30,
    display: 'block',
    textAlign: 'center',
    borderRadius: theme.spacing(1),
    color: theme.palette.grey[100],
    cursor: 'pointer',
  };
});

export const LeaderboardListItem = ({
  item,
  index,
  hideRating,
}: {
  index: number;
  item: LeaderBoardUser;
  hideRating?: boolean;
}) => {
  const scoreBgColor = ({ score }: { score: number }) => {
    if (score <= 15) {
      return 'error.main';
    }
    if (score > 15 && score <= 20) {
      return 'warning.main';
    }
    return 'success.main';
  };

  return (
    <Box
      display="grid"
      gridTemplateColumns="75% 25%"
      sx={{
        backgroundColor: item.me
          ? (theme) => (theme.palette.mode === 'light' ? 'grey.300' : 'grey.800')
          : 'transparent',
        py: 3,
      }}
    >
      <Box display="flex" alignItems="center">
        <Typography variant="text1" ml={7} mr={2} color="primary.main">
          {index + 2}
        </Typography>
        <Typography variant="text1">{item.fullName}</Typography>
      </Box>
      <Box display="flex" alignItems="center">
        {hideRating ? (
          <StyledLeaderboardScore
            textAlign="center"
            variant="text1"
            sx={{
              cursor: 'default',
              backgroundColor: () => scoreBgColor({ score: item.score }),
            }}
          >
            {Math.round(item.score * 10) / 10}
          </StyledLeaderboardScore>
        ) : (
          <LeaderboardTooltip rating={item.rating}>
            <StyledLeaderboardScore
              textAlign="center"
              variant="text1"
              sx={{
                backgroundColor: () => scoreBgColor({ score: item.score }),
              }}
            >
              {Math.round(item.score * 10) / 10}
            </StyledLeaderboardScore>
          </LeaderboardTooltip>
        )}
      </Box>
    </Box>
  );
};
